/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationRuleDto } from './notificationRuleDto';
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';
import { ShareDto } from './shareDto';
import { DeploymentDto } from './deploymentDto';
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { RequestedShare } from './requestedShare';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CollarExtendedDto { 
    id?: number;
    label?: string;
    role?: CollarExtendedDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    deviceTypeId?: string;
    deviceTypeCustomerName?: string;
    deviceTypeActivityChannelOrientations?: ActivityChannelOrientationConfiguration;
    parameterDataList?: Array<ParameterData>;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    updateTs?: string;
    pcbTypeId?: string;
    nfcTagUid?: string;
    comType?: CollarExtendedDto.ComTypeEnum;
    comId?: string;
    blacklisted?: boolean;
    lastReception?: string;
    lastReceptionDataEventType?: CollarExtendedDto.LastReceptionDataEventTypeEnum;
    notifications?: Array<NotificationRuleDto>;
    beaconFrequency?: number;
    networkStatus?: CollarExtendedDto.NetworkStatusEnum;
    dataPlan?: CollarExtendedDto.DataPlanEnum;
    airtimeOwnerNames?: Array<string>;
    airtimeOwnerEmails?: Array<string>;
    airtimeNetworkStatusChangeRequested?: CollarExtendedDto.AirtimeNetworkStatusChangeRequestedEnum;
    colorRgbCode?: string;
    deployments?: Array<DeploymentDto>;
    distanceLastPosition?: number;
    positionCount?: number;
    schedules?: Array<Schedule>;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    externalDropOffId?: number;
    internalDropOffId?: number;
    vhfBeaconTransmitterId?: number;
    availableEventUploadCount?: number;
    internalDropOffRadioFiringParameterData?: string;
    externalDropOffRadioFiringParameterData?: string;
    lastPositionLatitude?: number;
    lastPositionLongitude?: number;
    lastPositionMainVoltage?: number;
    lastPositionBackupVoltage?: number;
    lastPositionMortalityStatus?: CollarExtendedDto.LastPositionMortalityStatusEnum;
    lastPositionAcquisitionTime?: string;
    movebankForwardingStatus?: CollarExtendedDto.MovebankForwardingStatusEnum;
    esriForwardingStatus?: CollarExtendedDto.EsriForwardingStatusEnum;
    cameraId?: number;
}
export namespace CollarExtendedDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const LastReceptionDataEventTypeEnum = {
        Unknown: 'UNKNOWN',
        GpsPosition: 'GPS_POSITION',
        Separation: 'SEPARATION',
        TrapEvent: 'TRAP_EVENT',
        Proximity: 'PROXIMITY',
        Mortality: 'MORTALITY',
        MortalityImplant: 'MORTALITY_IMPLANT',
        VaginalImplant: 'VAGINAL_IMPLANT',
        Activity: 'ACTIVITY',
        GsmQuality: 'GSM_QUALITY',
        VirtualFence: 'VIRTUAL_FENCE',
        CollarLog: 'COLLAR_LOG'
    } as const;
    export type LastReceptionDataEventTypeEnum = typeof LastReceptionDataEventTypeEnum[keyof typeof LastReceptionDataEventTypeEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const LastPositionMortalityStatusEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type LastPositionMortalityStatusEnum = typeof LastPositionMortalityStatusEnum[keyof typeof LastPositionMortalityStatusEnum];
    export const MovebankForwardingStatusEnum = {
        On: 'ON',
        Off: 'OFF',
        NotAvailable: 'NOT_AVAILABLE'
    } as const;
    export type MovebankForwardingStatusEnum = typeof MovebankForwardingStatusEnum[keyof typeof MovebankForwardingStatusEnum];
    export const EsriForwardingStatusEnum = {
        On: 'ON',
        Off: 'OFF',
        NotAvailable: 'NOT_AVAILABLE'
    } as const;
    export type EsriForwardingStatusEnum = typeof EsriForwardingStatusEnum[keyof typeof EsriForwardingStatusEnum];
}


export type LastPositionMortalityStatusEnum = typeof CollarExtendedDto.LastPositionMortalityStatusEnum[keyof typeof CollarExtendedDto.LastPositionMortalityStatusEnum];
export type MovebankForwardingStatusEnum = typeof CollarExtendedDto.MovebankForwardingStatusEnum[keyof typeof CollarExtendedDto.MovebankForwardingStatusEnum];
export type EsriForwardingStatusEnum = typeof CollarExtendedDto.EsriForwardingStatusEnum[keyof typeof CollarExtendedDto.EsriForwardingStatusEnum];
